export enum AppsStatus {
   PAUSE = 0,
   ACTIVE = 1,
}
